// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airworthiness-directives.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airworthiness-directives/ad-exemption-and-alternative-means.js';
import g1 from '../lessons/air-law/airworthiness-directives/airworthiness-directives.js';

mount([g0, g1]);
